import * as React from 'react';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { PanelHeader, CloseButton, PanelBody, AutoScrollbars } from 'components';
import { CategorySelectorLite } from 'scenes/side-bar/category-selector-lite';
import { CategoryPanel } from 'scenes/side-bar/category-panel';
import { MobileUIAppHeader } from 'mobile-ui/components/app-header';
import { ProjectLayer } from 'types/omjs/project';
import { connect } from 'react-redux';
import { IState } from 'services/root-reducer';
import { getRoots } from 'selectors';
import i18n from 'i18next';

export interface IMobileUICategorySelectorProps {
    open: boolean;
    currentCategory: string;
    roots: ProjectLayer[];
    onClose: () => void;
    onCategoryClick: (category: IMobileUICategorySelectorProps['currentCategory']) => void;
    onSearchResultClick?: () => void
    searchOpen: boolean,
    searchResOpen: boolean
    toggleSearch: (v: boolean) => void,
    onToggleSearchRes: (v: boolean) => void
}

export interface IMobileUICategorySelectorState {
    searchOpen: boolean
}

const mapStateToProps = (state: IState) => ({
    roots: getRoots(state)
});

class MobileUICategorySelectorComponent extends React.Component<
IMobileUICategorySelectorProps,
IMobileUICategorySelectorState
> {
    constructor(props: IMobileUICategorySelectorProps) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        let title = 'root';
        if (this.props.currentCategory) {
            title = this.props.currentCategory;
        }
        document.title = i18n.t(title);
    }

    setShowSearch(show) {
        this.props.toggleSearch(show);
    }

    render() {
        let categoryContainer = this.props.roots.find(c => c.get('code') === this.props.currentCategory);
        let title = 'root';
        if (categoryContainer) {
            title = categoryContainer.get('code');
        }
        document.title = i18n.t(title);
        return (
            <SlideUpPanel
                open={this.props.open}
                className='mobile-ui-category-selector fix-close-button'
            >
                <PanelHeader>
                    <MobileUIAppHeader
                        onClose={this.props.onClose}
                        onCategorySelectorOpen={this.props.onCategoryClick}
                        onToggleSearch={(v) => this.setShowSearch(v)}
                        onToggleSearchRes={(v) => this.props.onToggleSearchRes(v)}
                        currentCategory={this.props.currentCategory}
                        onSearchResultClick={this.props.onSearchResultClick}
                        searchOpen={this.props.searchOpen}
                        searchResOpen={this.props.searchResOpen}
                    />
                </PanelHeader>

                {!this.props.searchOpen && (
                    <PanelBody>
                        <div className="category-container-header-name">
                            {categoryContainer?.get('name')}
                        </div>
                        <div className="scroll-fix" style={{ overflow: 'auto' }}>
                            <AutoScrollbars>
                                <CategoryPanel
                                    hideHints
                                    panelClassname='mobile-ui-category-panel'
                                    category={this.props.currentCategory}
                                />
                            </AutoScrollbars>
                        </div>
                    </PanelBody>
                )}
            </SlideUpPanel>
        );
    }
}

export const MobileUICategorySelector = connect(mapStateToProps)(MobileUICategorySelectorComponent);
